import type { Board } from 'containers/Ticketing/_api/types';
import type { Membership } from 'containers/Ticketing/_api/useGetTicketingBoardMembership/types';
import type { ImmerStateCreator } from 'hooks/useStore';

export interface TicketingSlice {
  selectedTicketId: string;
  ticketingBoards: Board[];
  ticketingBoardMembership?: Membership;
  showCreateTicketModal: boolean;
  setSelectedTicketId: (id: string) => void;
  setTicketingBoards: (boards: Board[]) => void;
  setTicketingBoardMembership: (membership: Membership) => void;
  setShowCreateTicketModal: (show: boolean) => void;
}

export const useTicketingSlice: ImmerStateCreator<TicketingSlice> = (set) => ({
  selectedTicketId: '',
  ticketingBoards: [],
  showCreateTicketModal: false,
  setSelectedTicketId: (id: string) =>
    set(
      (state) => {
        state.ticketingSlice.selectedTicketId = id;
      },
      false,
      'setSelectedTicketId'
    ),
  setTicketingBoards: (boards: Board[]) =>
    set(
      (state) => {
        state.ticketingSlice.ticketingBoards = boards;
      },
      false,
      'setTicketingBoards'
    ),
  setTicketingBoardMembership: (membership: Membership) =>
    set(
      (state) => {
        state.ticketingSlice.ticketingBoardMembership = membership;
      },
      false,
      'setTicketingBoards'
    ),
  setShowCreateTicketModal: (value: boolean) =>
    set(
      (state) => {
        state.ticketingSlice.showCreateTicketModal = value;
      },
      false,
      'setShowCreateTicketModal'
    ),
});
